import { render } from "./SpendingPlanManagement.vue?vue&type=template&id=5c9bd842&scoped=true"
import script from "./SpendingPlanManagement.vue?vue&type=script&lang=js"
export * from "./SpendingPlanManagement.vue?vue&type=script&lang=js"

import "./SpendingPlanManagement.vue?vue&type=style&index=0&id=5c9bd842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9bd842"]])

export default __exports__